const permissions = {
  FLIGHT_LIST: "FLIGHT_LIST",
  SEARCH_PASSENGERS: "SEARCH_PASSENGERS",
  ROLE_MANAGE: "ROLE_MANAGE",
  USER_MANAGE: "USER_MANAGE",
  API_AUDIT_SEARCH: "API_AUDIT_SEARCH",
  ORGANIZATION_MANAGE: "ORGANIZATION_MANAGE",
  AIRPORT_MANAGE: "AIRPORT_MANAGE",
  RISK_MANAGE: "RISK_MANAGE",
  INTERNATIONAL: "INTERNATIONAL",
  DOMESTIC: "DOMESTIC",
  USER_AIRPORT: "USER_AIRPORT",
  ORGANIZATION_AIRPORT: "ORGANIZATION_AIRPORT",
  RESTRICTION_LIST: "RESTRICTION_LIST",
  CATEGORY_MANAGE: "CATEGORY_MANAGE",
  EXPORT_APIPNR: "EXPORT_APIPNR",
  INSPECTION_REPORT: "INSPECTION_REPORT",
  INSPECTION_SYNTHETIC: "INSPECTION_SYNTHETIC",
  INSPECTION_ANALITIC: "INSPECTION_ANALITIC",
  INDICATORS_TOTALIZATORS: "INDICATORS_TOTALIZATORS",
  COUNTRY_MANAGE: "COUNTRY_MANAGE",
  SEARCH_CREW: "SEARCH_CREW",
  AIRLINE_MANAGE: "AIRLINE_MANAGE",
  API_PNR_PANEL: "API_PNR_PANEL",
  WORK_TEAM_MANAGE: "WORK_TEAM_MANAGE",
  SISBRAIP_INDICATORS_REPORT: "SISBRAIP_INDICATORS_REPORT",
  UPDATES_EDIT: "UPDATES_EDIT",
  UPDATES_READ: "UPDATES_READ",
  ICON_ACTION_MANAGE: "ICON_ACTION_MANAGE",
  TISBA: "TISBA",
  DOWNLOAD_TISBA_TCSV: "DOWNLOAD_TISBA_TCSV",
  DELETE_OCURRENCE: "DELETE_OCURRENCE",
  INSPECTIONS_AND_OCCURENCIES: "INSPECTIONS_AND_OCCURENCIES",
  HELP_EDIT: "HELP_EDIT",
  HELP_READ: "HELP_READ",
  VISUALIZE_RAW_PNR: "VISUALIZE_RAW_PNR",  
  TCSV: "TCSV",
  ITINERARY_SEARCH: "ITINERARY_SEARCH",
  VISUALIZE_SINPA: "VISUALIZE_SINPA",
  VISUALIZE_NOFLY: "VISUALIZE_NOFLY",
};

export default permissions;
